import styled from 'styled-components';
import { StateHintContainer } from '../StateHint/styles';

export const UnitHintContainer = styled(StateHintContainer)`
  height: 100px;
  flex-direction: row;
  gap: 8px;
`;
